import AbstractAxiosService from './AbstractAxiosService'
import axios from 'axios'

export default class DieciContaoService extends AbstractAxiosService {
  constructor (options = {}) {
    super(options)
  }

  // cart
  cart () {
    return this.makeRequest('GET', '/cartdata/getBasketSummary', { withCredentials: true })
  }

  // location
  searchZip ({ zip, lang, orderType }) {
    return this.makeRequest('POST', '/api/zip', { zip, searchByZip: 1, orderType }, { urlencoded: true, params: { lang } })
  }

  // account
  accountLastOrders () {
    return this.makeRequest('GET', '/customerdata/listOrderPublic', { withCredentials: true })
  }

  accountSelectOrder ({ json, url }) {
    // this request has to be special
    if (this.mock) {
      return this.makeRequest('POST', '/customerdata/selectOrder', json, { withCredentials: true })
    }
    return axios.post(
      url,
      json,
      { withCredentials: true }
    )
      .then((response) => this.translateApi(response))
      .catch((err) => this.translateError(err))
  }
}
